import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { Sparkles, LayoutDashboard, ShoppingBag, Package, ScrollText, LogOut, Menu, X } from "lucide-react";
import { api } from "@/lib/api";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/packages", label: "Packages", icon: Package },
  { to: "/admin/audit", label: "Audit Log", icon: ScrollText },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const [ok, setOk] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/admin/me").then(() => setOk(true)).catch(() => { nav("/admin/login"); });
  }, [nav]);

  const logout = async () => {
    try { await api.post("/admin/logout"); } finally { nav("/admin/login"); }
  };

  if (!ok) return <div className="min-h-screen bg-slate-50 flex items-center justify-center text-slate-400">Loading…</div>;

  const sidebar = (
    <div className="h-full flex flex-col">
      <Link to="/admin" className="flex items-center gap-2 px-6 h-16 border-b border-white/10">
        <Sparkles className="w-5 h-5 text-gold" />
        <span className="font-serif text-2xl text-ivory">Aetheria</span>
      </Link>
      <nav className="flex-1 p-4 space-y-1">
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)}
            data-testid={`admin-nav-${n.label.toLowerCase().replace(" ", "-")}`}
            className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-gold text-white" : "text-slate-300 hover:bg-white/10"}`}>
            <n.icon className="w-4 h-4" /> {n.label}
          </NavLink>
        ))}
      </nav>
      <button onClick={logout} data-testid="admin-logout" className="flex items-center gap-3 px-6 py-4 text-sm text-slate-300 hover:text-white border-t border-white/10">
        <LogOut className="w-4 h-4" /> Sign out
      </button>
    </div>
  );

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <aside className="hidden lg:block w-64 bg-navy fixed inset-y-0 left-0">{sidebar}</aside>
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="w-64 bg-navy">{sidebar}</div>
          <div className="flex-1 bg-black/40" onClick={() => setOpen(false)} />
        </div>
      )}
      <div className="flex-1 lg:ml-64">
        <header className="lg:hidden bg-navy h-14 flex items-center justify-between px-4">
          <span className="font-serif text-xl text-ivory">Aetheria Admin</span>
          <button onClick={() => setOpen(true)} data-testid="admin-mobile-menu" className="text-ivory"><Menu className="w-6 h-6" /></button>
        </header>
        <main className="p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
